export enum PlanType {
    Free = 'Free',
    Silver = 'Silver',
    Bronze = 'Bronze',
    Golden = 'Golden',
    Platinum = 'Platinum',
}

export const PlanTypeTranslations: Record<PlanType, string> = {
    [PlanType.Free]: 'مجاني',
    [PlanType.Silver]: 'فضي',
    [PlanType.Bronze]: 'برونزي',
    [PlanType.Golden]: 'ذهبي',
    [PlanType.Platinum]: 'بلاتيني',
};
